import { requiredInputRule } from "@erp/shared/utils/form/rules";
import { formatDate, formatHour } from "@erp/shared/utils/date/formatted-date";
export const shipSearchHeaders = [
    { text: "종류", align: "start", value: "type" },
    { text: "분류", align: "start", value: "classification" },
    { text: "관리코드", align: "start", value: "productCode" },
    { text: "제품명", align: "start", value: "name" },
    { text: "모델명", align: "start", value: "model" },
    { text: "사양", align: "start", value: "spec" },
    { text: "제조사", align: "start", value: "manufacturer" },
    { text: "출고위치", align: "start", value: "outboundSpotName" },
    { text: "출고수량", align: "start", value: "outboundNum" },
    { text: "출고요청일", align: "start", value: "outboundDate" },
    { text: "추가", align: "center", value: "actions", sortable: false },
];
export const searchShipCardInputs = [
    {
        label: "프로젝트",
        key: "projectCode",
        col: "12",
        sm: "4",
        lg: "3",
        value: "",
        clearable: true,
    },
    {
        label: "관리코드",
        key: "productCode",
        col: "12",
        sm: "4",
        lg: "3",
        value: "",
        clearable: true,
    },
    {
        label: "제품명",
        key: "name",
        col: "12",
        sm: "4",
        lg: "3",
        value: "",
        clearable: true,
    },
    {
        label: "출고목적",
        key: "purpose",
        col: "12",
        sm: "4",
        lg: "3",
        value: "",
        clearable: true,
    },
    {
        label: "출고 요청일",
        key: "outboundDate",
        type: "dateSingle",
        value: "",
        col: "12",
        sm: "4",
        lg: "3",
    },
];
export const restockCardInfoInputs = [
    {
        label: "입고일자",
        key: "inboundDate",
        column_name: "inboundDate",
        type: "dateSingle",
        value: formatDate(),
        col: "12",
        sm: "4",
        lg: "4",
        menu: "",
        rules: [requiredInputRule],
    },
    {
        label: "입고시간",
        key: "inboundTime",
        column_name: "inboundTime",
        type: "hour",
        value: formatHour(),
        col: "12",
        sm: "4",
        lg: "4",
        rules: [requiredInputRule],
    },
    {
        label: "재입고 사유",
        key: "note",
        column_name: "note",
        type: "textarea",
        col: "12",
        sm: "4",
        lg: "4",
        value: "",
        clearable: true,
        rules: [requiredInputRule],
    },
];
export const shipmentChecks = [
    {
        validator: (data) => !!data.num,
        errorMessage: "재입고수량 필수 입력",
    },
    {
        validator: (data) => {
            const numStr = String(data.num).replace(/[, \s]/g, "");
            const restockNum = Number(numStr);
            return !isNaN(restockNum) && restockNum > 0;
        },
        errorMessage: "재입고 수량은 0보다 커야합니다.",
    },
    {
        validator: (data) => {
            const restockNum = Number(String(data.num).replace(/[, \s]/g, ""));
            return !isNaN(restockNum);
        },
        errorMessage: "재입고 수량 정보를 확인할 수 없습니다.",
    },
    {
        validator: (data) => {
            const numStr = String(data.num).replace(/[, \s]/g, "");
            const restockNum = Number(numStr);
            const outboundNum = Number(String(data.outboundNum).replace(/[, \s]/g, ""));
            return restockNum <= outboundNum;
        },
        errorMessage: "재입고 수량은 출고된 수량보다 같거나 작아야합니다.",
    },
];
